import { Skeleton, SkeletonProps } from '@mui/material';

export const LoadingSkeleton = ({ sx, ...props }: SkeletonProps) => {
  return <Skeleton sx={{ ...sx, transform: 'none' }} {...props} />;
};
